import { render, staticRenderFns } from "./StraightendProtein.vue?vue&type=template&id=389000ac&scoped=true&"
import script from "./StraightendProtein.vue?vue&type=script&lang=js&"
export * from "./StraightendProtein.vue?vue&type=script&lang=js&"
import style0 from "./StraightendProtein.vue?vue&type=style&index=0&id=389000ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389000ac",
  null
  
)

export default component.exports